import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getPlanBenefits } from '../../../api/plan-benefit-override-rules-api'
import type {
  PlanBenefitItemDto,
  PlanBenefitName,
} from '../../../api/dto/plan-benefit-override-rules.dto'

export const PLAN_BENEFITS_QUERY_KEY = 'planBenefits'

const EMPTY_BENEFITS: PlanBenefitItemDto[] = []

export function useGetPlanBenefits() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [PLAN_BENEFITS_QUERY_KEY],
    queryFn: getPlanBenefits,
    staleTime: Infinity,
  })

  const benefits = data?.benefits ?? EMPTY_BENEFITS

  const benefitsByName = useMemo(() => {
    const map: Partial<Record<PlanBenefitName, PlanBenefitItemDto>> = {}
    for (const b of benefits) {
      map[b.name] = b
    }
    return map
  }, [benefits])

  const orderedBenefits = useMemo(
    () => [...benefits].sort((a, b) => a.sortOrder - b.sortOrder),
    [benefits]
  )

  return {
    benefits: orderedBenefits,
    benefitsByName,
    isLoading,
    error,
    refetch,
  }
}
